<template>
    <div>
        <Modal v-if="showModal" ref="modal-branches" id="modal-branches" centered :scrollable="postalCodeSend"
               :size="'md'" @close="hide()">
            <div slot="header" class="px-3 pt-3 select-branch-modal-header">
                <h2 class="select-branch-modal-title">Selecciona tu sucursal más cercana para recibir noticias y promociones</h2>
                <div v-show="postalCodeSend && locations.length > 0" class="select-branch-modal-postal-code-container">
                    <label class="select-branch-modal-postal-code-label">Buscar otro código postal</label>
                    <div class="select-branch-modal-postal-code-input">
                        <div id="geocoderHeader"></div>
                    </div>
                </div>
                <div v-show="postalCodeSend" class="select-branch-modal-branches-header-info">
                    <p>Código postal: <strong style="color: #2c5697">{{ postalCode }}</strong></p>
                    <p>{{ locations.length }} resultados</p>
                </div>
            </div>
            <div slot="body">
                <div v-show="!postalCodeSend" class="select-branch-modal-container">
                    <button class="btn btn-primary btn-orange mb-3" @click="geoFindMe()">
                        <span>Activar mi geolocalización</span>
                    </button>
                    <span class="select-branch-modal-title" style="margin-bottom: 4px">o</span>
                    <div class="select-branch-modal-postal-code-container">
                        <label class="select-branch-modal-postal-code-label">Ingresa tu código postal y selecciona un
                            resultado</label>
                        <div class="select-branch-modal-postal-code-input">
                            <div id="geocoder"></div>
                        </div>
                    </div>
                </div>
                <div v-show="postalCodeSend" class="select-branch-modal-branches-container">
                    <div v-show="!locationsLoading && locations.length === 0" class="select-branch-modal-branches-retry">
                        <p>No hay sucursales cerca de ti</p>
                        <button class="btn btn-primary btn-orange m-0" @click="retrySearch()">
                            <span>Intenta de nuevo</span>
                        </button>
                    </div>
                    <div v-if="locationsLoading" class="spinner-border"
                         style="color: #2c5697; width: 3rem; height: 3rem;"></div>
                    <div v-else class="select-branch-modal-branches-list">
                        <div v-for="location in locations" class="select-branch-modal-branch-container">
                            <div class="select-branch-modal-branch-header">
                                <p><strong>{{ location.title }}</strong></p>
                                <p><strong>({{ location.distance.toFixed(2) }} Km)</strong></p>
                            </div>
                            <p>{{ location.store }}</p>
                            <p>{{ location.address }}</p>
                            <p>{{ location.store_schedule[0].days }} de
                                <strong>{{ formatTime(location.store_schedule[0].open_time) }} -
                                    {{ formatTime(location.store_schedule[0].close_time) }}</strong></p>
                            <div class="select-branch-modal-branch-button">
                                <button class="btn btn-primary btn-orange m-2" @click="$emit('select-branch', location);hide();">
                                    Seleccionar esta sucursal
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from './Modal.vue';

export default {
    components: {Modal},
    data() {
        return {
            postalCode: '',
            postalCodeSend: false,
            selectedBranch: null,
            positions: {
                coords: {
                    latitude: null,
                    longitude: null,
                },
            },
            radio_distance: 20000,
            locations: [],
            locationsLoading: false,
            showModal: false,
        }
    },
    created() {
        this.$bus.$on("open-select-branch-modal", (payload) => {
            this.show()
        })
    },
    methods: {
        show() {
            this.showModal = true
            setTimeout(() => {
                this.setUpGeocoder()
            }, 1)
        },
        hide() {
            this.showModal = false
        },
        searchByPostalCode() {
            this.postalCodeSend = true
            this.locationsLoading = true
            this.getLocations()
        },
        formatTime(time) {
            return this.$moment(time, 'hh:mm A').format('hh:mm A')
        },
        setUpGeocoder() {
            //mapboxgl.accessToken = this.$config.MAPBOX_ACCESS_TOKEN
            mapboxgl.accessToken = "pk.eyJ1IjoicmdnZWVrIiwiYSI6ImNrYThndW83bDBmdDAyeXF2dnlzdGw5bjcifQ.rj8xhxIcO9Csy9NMZR63Xg"

            const getItemValue = (item) => item.text

            const result = (e) => {
                this.positions.coords.latitude = e.result.geometry.coordinates[1]
                this.positions.coords.longitude = e.result.geometry.coordinates[0]
                this.postalCode = e.result.text
                this.searchByPostalCode()
            }

            const results = (e) => {
                if (e.features.length === 0) {
                    const noResultsContainer = document.querySelector(".mapbox-gl-geocoder--no-results");
                    noResultsContainer.innerHTML = "No hay resultados";
                }
            }

            const config = {
                countries: 'MX',
                accessToken: mapboxgl.accessToken,
                placeholder: 'Código postal',
                language: 'es-MX',
                types: 'postcode',
                getItemValue,
            }

            const geocoder = new MapboxGeocoder(config)
            geocoder.addTo('#geocoder')
            geocoder.on('result', result)
            geocoder.on('results', results)

            const geocoderHeader = new MapboxGeocoder(config)
            geocoderHeader.addTo('#geocoderHeader')
            geocoderHeader.on('result', result)
            geocoderHeader.on('results', results)
        },
        retrySearch() {
            this.postalCodeSend = false
            this.postalCode = ''
        },
        geoFindMe() {
            this.postalCodeSend = true
            this.locationsLoading = true

            let positionsPromise = new Promise((resolve, reject) => {
                let lat, lng
                navigator.geolocation.getCurrentPosition((pos) => {
                    lat = pos.coords.latitude
                    lng = pos.coords.longitude
                    resolve({lat, lng})
                }, async () => {
                    let pos = await this.no_current_location()
                    lat = pos[0]
                    lng = pos[1]
                    resolve({lat, lng})
                })
            })

            positionsPromise.then((value) => {
                this.positions = {
                    coords: {
                        latitude: value.lat,
                        longitude: value.lng
                    }
                }

                this.getLocations()
                this.getPostalCodeWithGeolocation()
            })
        },
        getPostalCodeWithGeolocation() {
            let config = {
                method: 'get',
                url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.positions.coords.longitude},${this.positions.coords.latitude}.json?types=postcode&access_token=${mapboxgl.accessToken}`,
                headers: {}
            }

            this.$axios.request(config)
                .then((response) => {
                    this.postalCode = response.data.features[0].text
                })
                .catch((error) => {
                    console.error(error)
                })
        },
        getLocations() {
            let params = {
                lat: this.positions.coords.latitude,
                lng: this.positions.coords.longitude,
                radius: this.radio_distance,
                vta: false
            }
            let config = {
                params: params
            }
            this.$axios.get('api/get-locations', config).then(res => {
                this.updateStoresLocations(res.data.data, this.positions.coords.longitude, this.positions.coords.latitude)
            })
        },
        updateStoresLocations(locationsResponse, lng, lat) {
            this.locations = []
            locationsResponse.forEach((loc) => {
                let geodata = {
                    lat: loc.coordinates[1],
                    lng: loc.coordinates[0]
                }
                if (!geodata) {
                    return false
                }
                let location = {
                    distance: this.getDistanceFromLatLonInKm(lat, lng, geodata.lat, geodata.lng),
                    id: loc['_id']['$oid'],
                    'location-id': loc.location_id,
                    title: loc.title,
                    store: loc.store,
                    address: loc.address,
                    country: loc.country,
                    zip_code: loc.zip_code,
                    lat: geodata.lat,
                    lng: geodata.lng,
                    store_schedule: loc.schedule,
                    is_new: loc.is_new,
                    relationships: loc.relationships,
                    hasCatalog: loc.has_catalog,
                    favorite: false,
                    default_photo: null,
                    // has_appointments: loc.relationships.calendars.length > 0,
                    is_vta: loc.is_vta,
                    california_id: loc.california_id,
                    actualPosition: this.positions,
                }
                this.locations.push(location)
            });
            this.locations.sort((distance1, distance2) => distance1.distance - distance2.distance);
            this.locationsLoading = false
        },
        no_current_location() {
            let latitude, longitude
            return new Promise(async (resolve) => {
                let ip
                await fetch("https://api.ipify.org?format=json", {
                    method: 'GET',
                    redirect: 'follow'
                })
                    .then(response => response.json())
                    .then(result => {
                        ip = result.ip
                    })
                    .catch(error => console.error(error))
                this.$axios.get('/api/geoposition', {params: {ip}})
                    .then(response => {
                        latitude = response.data.data.latitude
                        longitude = response.data.data.longitude
                        resolve([latitude, longitude])
                    })
            })
        },
        // TODO: Mandar funciones a mixin
        getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            let R = 6371; // Radius of the earth in km
            let dLat = this.deg2rad(lat2 - lat1)  // this.deg2rad below
            let dLon = this.deg2rad(lon2 - lon1)
            let a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
            return R * c; // Distance in km
        },
        deg2rad(deg) {
            return deg * (Math.PI / 180)
        },
    },
}
</script>

<style lang="scss" scoped>
#geocoderHeader {
    width: 100%;
}

.select-branch-modal-header {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.select-branch-modal-title {
    text-align: center;
    font-size: 20px;
    color: #2c5697;
    font-weight: bolder;
}

.select-branch-modal-postal-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;
    width: 100%;
}

.select-branch-modal-postal-code-label {
    font-size: 14px;
    color: #797979;
}

.select-branch-modal-postal-code-input {
    display: flex;
    justify-content: center;
    width: 90%;

    input[type=text] {
        background: white;
        height: 40px;
        border: 1px solid lightgray;
    }
}

.select-branch-modal-branches-header-info {
    width: 90%;
    display: flex;
    justify-content: space-between;

    p {
        width: fit-content;
    }
}

.select-branch-modal-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
}

.select-branch-modal-branches-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.select-branch-modal-branches-retry {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #797979;

    button {
        max-width: fit-content;
    }
}

.select-branch-modal-branches-list {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1rem;
}

.select-branch-modal-branch-container {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    border-radius: 0.3rem;
    padding: 10px;
    color: #757575;
    font-size: 14px;
    width: 100%;

    p {
        margin-bottom: 10px;
    }

    strong {
        color: #000;
    }
}

.select-branch-modal-branch-header {
    display: flex;
    justify-content: space-between;

    p {
        width: fit-content;
        font-size: 16px;
        font-weight: bolder;
        margin-bottom: 0;
    }
}

.select-branch-modal-branch-button {
    display: flex;
    justify-content: center;
}

::v-deep .modal-content {
    border-radius: 1rem;
}

::v-deep .modal-md {
    min-height: 200px !important;
}

::v-deep .mapboxgl-ctrl-geocoder,
.mapboxgl-ctrl-geocoder *,
.mapboxgl-ctrl-geocoder *:after,
.mapboxgl-ctrl-geocoder *:before {
    box-sizing: border-box;
}

::v-deep .mapboxgl-ctrl-geocoder {
    font-size: 16px;
    line-height: 24px;
    font-family: "Open Sans", "Helvetica Neue", Arial, Helvetica, sans-serif;
    position: relative;
    background-color: #fff;
    width: 100%;
    min-width: 100px;
    z-index: 1;
    border-radius: 4px;
    transition: width .25s, min-width .25s;
}

::v-deep .mapboxgl-ctrl-geocoder--input {
    font: inherit;
    width: 100%;
    height: 36px !important;
    border: 1px solid #d8d8d8;
    background-color: #fff !important;
    margin: 0;
    /* fallback */
    color: rgba(0, 0, 0, 0.75);
    padding: 6px 10px 6px 40px;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

::v-deep .mapboxgl-ctrl-geocoder--input::-ms-clear {
    display: none;
    /* hide input clear button in IE */
}

::v-deep .mapboxgl-ctrl-geocoder--input:focus {
    color: #404040;
    /* fallback */
    color: rgba(0, 0, 0, 0.75);
    box-shadow: none;
}

::v-deep .mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--pin-right > * {
    z-index: 2;
    position: absolute;
    right: 8px;
    top: 7px;
    display: none;
}

/* Collapsed */

::v-deep .mapboxgl-ctrl-geocoder.mapboxgl-ctrl-geocoder--collapsed {
    width: 50px;
    min-width: 50px;
    transition: width .25s, min-width .25s;
}

/* Suggestions */

::v-deep .mapboxgl-ctrl-geocoder .suggestions {
    background-color: #fff;
    border-radius: 4px;
    left: 0;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    width: 100%;
    /* fallback */
    top: calc(100% + 1px);
    z-index: 1000;
    overflow: hidden;
    font-size: 15px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

::v-deep .mapboxgl-ctrl-bottom-left .suggestions,
.mapboxgl-ctrl-bottom-right .suggestions {
    top: auto;
    bottom: 100%;
}

::v-deep .mapboxgl-ctrl-geocoder .suggestions > li > a {
    cursor: default;
    display: block;
    padding: 6px 12px;
    color: #404040;
}

::v-deep .mapboxgl-ctrl-geocoder .suggestions > .active > a,
.mapboxgl-ctrl-geocoder .suggestions > li > a:hover {
    color: #404040;
    background-color: #f3f3f3;
    text-decoration: none;
    cursor: pointer;
}

::v-deep .mapboxgl-ctrl-geocoder--suggestion-title {
    font-weight: 600;
}

::v-deep .mapboxgl-ctrl-geocoder--suggestion-title,
.mapboxgl-ctrl-geocoder--suggestion-address {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

/* Icons */

::v-deep .mapboxgl-ctrl-geocoder--icon {
    vertical-align: middle;
    speak: none;
    fill: #757575;
    top: 15px;
}

::v-deep .mapboxgl-ctrl-geocoder--icon-search {
    position: absolute;
    top: 6px;
    left: 8px;
    width: 23px;
    height: 23px;
    filter: saturate(100%) brightness(0) invert(69%) sepia(74%) saturate(3225%) hue-rotate(349deg) brightness(102%) contrast(102%);
}

::v-deep .mapboxgl-ctrl-geocoder--button {
    padding: 0;
    margin: 0;
    border: none;
    cursor: pointer;
    background: #fff;
    line-height: 1;
}

::v-deep .mapboxgl-ctrl-geocoder--icon-close {
    width: 20px;
    height: 20px;
    margin-top: 8px;
    margin-right: 3px;
    display: none;
}

::v-deep .mapboxgl-ctrl-geocoder--button:hover .mapboxgl-ctrl-geocoder--icon-close {
    fill: #909090;
}

::v-deep .mapboxgl-ctrl-geocoder--icon-loading {
    width: 26px;
    height: 26px;
    margin-top: 30px;
    margin-right: 40%;
    -moz-animation: rotate 0.8s infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);
    -webkit-animation: rotate 0.8s infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);
    animation: rotate 0.8s infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);
    display: none !important;
}

@media (max-width: 441px) {
    button {
        max-width: 100%;
        text-align: center;
    }

    .select-branch-modal-branches-header-info {
        width: 100%;
    }

    .select-branch-modal-branches-list {
        width: 100%;
    }
}
</style>